// extracted by mini-css-extract-plugin
export default {"input":"InputPasswordCore_input__qUZSy"};